import MadUpPhysio from './MadUpPhysio';

export default MadUpPhysio;